import classNames from 'classnames';

import { commonTopnavStripClasses } from '../TopNav/constants';

export const LoadingRibbon = () => <div className={classNames(commonTopnavStripClasses, 'opacity-0')}>Bezel</div>;
